import { z } from 'zod';
export const verifyBodySchema = z.object({
    idPervye: z.coerce.number().int().positive(),
    email: z.string().email().transform((e) => e.trim().toLowerCase()),
});
export const loginVkBodySchema = z.object({
    launchParams: z.string().min(1),
});
export const staffCreateBodySchema = z.object({
    vkUserId: z.coerce.number().int().positive(),
    role: z.enum(['admin', 'viewer']),
    fullName: z.string().trim().min(1).max(200).optional(),
});
export const staffUpdateBodySchema = z
    .object({
    role: z.enum(['admin', 'viewer']).optional(),
    fullName: z.string().trim().min(1).max(200).optional(),
})
    .refine((data) => data.role !== undefined || data.fullName !== undefined, {
    message: 'Укажите роль или имя',
});
